export enum NotificationType {
  Send = 'TMR:Send',
  Receive = 'TMR:Receive',
  INGREDIENT_UPDATED = 'TMR:INGREDIENT_UPDATED',
  RATION_UPDATED = 'TMR:RATION_UPDATED',
  PREMIX_UPDATED = 'TMR:PREMIX_UPDATED',
  GROUP_UPDATED = 'TMR:GROUP_UPDATED',
  GROUPTYPE_UPDATED = 'TMR:GROUPTYPE_UPDATED',
  PERIOD_UPDATED = 'TMR:PERIOD_UPDATED',
  MIXER_UPDATED = 'TMR:MIXER_UPDATED',
  DRIVER_UPDATED = 'TMR:DRIVER_UPDATED',
  BATCH_UPDATED = 'TMR:BATCH_UPDATED',
  PARAMS_UPDATED = 'TMR:PARAMS_UPDATED',
  HMSGROUP_UPDATED = 'TMR:HMSGROUP_UPDATED',
  LOTTYPE_UPDATED = 'TMR:LOTTYPE_UPDATED',
  LOTMARKETTYPE_UPDATED = 'TMR:LOTMARKETTYPE_UPDATED',
  MIXERSTATUS_UPDATED = 'TMR:MIXERSTATUS_UPDATED',
  MILKING_UPDATED = 'TMR:MILKING_UPDATED',
  MILKPRICE_UPDATED = 'TMR:MILKPRICE_UPDATED',
  CONCENTRATE_UPDATED = 'TMR:CONCENTRATE_UPDATED',
  WEIGHBRIDGE_TICKET_UPDATED = 'TMR:WEIGHBRIDGE_TICKET_UPDATED',
  WIDGET_INVENTORY = 'TMR:WIDGET_INVENTORY',
  WIDGET_LOADS = 'TMR:WIDGET_LOADS',
  WIDGET_DELIVERIES = 'TMR:WIDGET_DELIVERIES',
  STOCK_TRANSACTION_UPDATED = 'TMR:STOCK_TRANSACTION_UPDATED',
  RELATION_UPDATED = 'TMR:RELATION_UPDATED',
}

export enum NotificationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Warning = 'WARNING',
}

export interface NotificationEvent {
  type: NotificationType;
  recipients: string[];
  content: NotificationEventContent;
}

export interface NotificationEventContent {
  device: string;
  channel: string;
  status: NotificationStatus;
  code: number;
  message: string;
  annotation?: string;
  mixerId: string;
}
